import { Component } from '@opten/gin-tonic/helpers/compiler';

// @ts-ignore - typings resolution issue with swiper exports in this setup
import Swiper, { Pagination, A11y, Navigation, Autoplay } from 'swiper';

@Component({ className: 'js-gallery-slider-mobile' })
export class GallerySliderMobileComponent {
	constructor(private element: HTMLElement) {
		Swiper.use([Pagination, A11y, Navigation, Autoplay]);
		const container = (this.element as HTMLElement).closest(
			'.js-scroll-gallery'
		) as HTMLElement | null;
		const nextEls = container?.querySelectorAll('.swiper-button-next') as
			| NodeListOf<HTMLElement>
			| undefined;
		const prevEls = container?.querySelectorAll('.swiper-button-prev') as
			| NodeListOf<HTMLElement>
			| undefined;
		const nextEl = nextEls && nextEls.length ? Array.from(nextEls) : undefined;
		const prevEl = prevEls && prevEls.length ? Array.from(prevEls) : undefined;
		const paginationEl = container?.querySelector(
			'.swiper-pagination'
		) as HTMLElement | null;
		new Swiper(this.element as HTMLElement, {
			loop: true,
			centeredSlides: false,
			slidesPerView: 1,
			spaceBetween: 20,
			// navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
			pagination: paginationEl
				? {
						el: paginationEl,
						clickable: true,
				  }
				: undefined,
			// a11y: {
			// 	prevSlideMessage: 'Previous',
			// 	nextSlideMessage: 'Next',
			// },
		});
	}
}
